import { TitleCasePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '@piqet-angular/data';
import {
  CustomModalService,
  FileUploadComponent,
  FileUploadResult,
  projectsPlaceholder,
} from '@piqet-angular/shared';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'piqet-angular-new-product-project',
  templateUrl: './new-product-project.component.html',
  styleUrls: ['./new-product-project.component.scss'],
  providers: [TitleCasePipe],
})
export class NewProductProjectComponent {
  @ViewChild('fileUploadComponent') fileUploadComponent!: FileUploadComponent;
  @Output() saveNewMyProductProjectEvent = new EventEmitter<any>();
  projectsPlaceholder = projectsPlaceholder;

  modalLabel: any;
  submitted = false;
  productProjectForm!: FormGroup;
  productProjectData: any;
  selectedFiles: string | null = null;
  fileBase64: string | null = null;
  existingImageUrl: string | null = null;
  existingFileName: string | null = null;

  unitList: any;
  selectedCurrency: any;
  unitId: any;
  currencyList: any;
  showCurrencyList: any;
  isCostTurnedOff: boolean = false;
  currencyItem: any;
  defaultRegionItems: any;
  selectCountry: any;
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly modal: CustomModalService,
    private readonly toaster: ToastrService
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.productProjectData =
      this.modal?.modalService?.config?.initialState?.['newMyProductProjects'];
    this.unitList = this.productProjectData.unitList;
    this.defaultRegionItems = this.productProjectData.countryItems;
    this.currencyList = this.productProjectData?.currencyItems;
    this.setCurrency();
    this.initializeExistingFile();
  }

  private initializeExistingFile(): void {
    // If editing existing product with image, set the existing file info
    if (this.productProjectData?.productContentsImage) {
      // If you have a URL for the existing image
      this.existingImageUrl = this.productProjectData.productImageUrl || null;
      this.existingFileName = this.productProjectData.productContentsFile || null;
      this.fileBase64 = this.productProjectData.productContentsImage;
      this.selectedFiles = this.existingFileName;
    }
  }

  ngOnInit(): void {
    this.productProjectForm = this.formBuilder.group({
      productName: ['', [Validators.required, noWhitespaceValidator]],
      country: [null],
      defaultCountry: [null, Validators.required],
      description: [null],
      unit: [null, Validators.required],
      currency: [null],
    });

    this.setFormData();
    if (this.productProjectData.productCountries?.length) {
      const selectedCountries = this.defaultRegionItems.filter((country: any) =>
        this.productProjectData.productCountries.includes(country.id)
      );
      this.productProjectForm.patchValue({
        country: selectedCountries,
      });
      this.selectCountry = selectedCountries;
    }
  }

  async setCurrency() {
    await this.currencyList?.map((data: any) => {
      if (data?.id == this.productProjectData?.currencyId) {
        return (this.currencyItem = data);
      }
    });
  }

  setFormData() {
    this.productProjectForm.patchValue({ currency: this.currencyItem });
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  defalutCountry(selectCountry: any) {
    if (this.productProjectForm.controls['defaultCountry']?.value?.id) {
      const data = selectCountry.find((data: any) => {
        if (data.id == this.productProjectForm.controls['defaultCountry']?.value.id) {
          return true;
        }
      });
      if (!data) {
        this.productProjectForm.controls['defaultCountry'].setValue(null);
      }
    }
    this.selectCountry = selectCountry.length == 0 ? this.defaultRegionItems : selectCountry;
  }

  changeUnit(eve: any) {
    if (eve?.id) {
      this.unitId = eve?.id;
    }
  }

  costTurnOff(event: any) {
    if (event.target.checked && !this.productProjectData.currencyId) {
      // FOR setting USD as default currency if none is selected
      this.productProjectForm
        ?.get('currency')
        ?.setValue(this.productProjectData?.currencyItems?.find((x: any) => x.id == 1));
    }
    this.showCurrencyList = event.target.checked ? true : false;
  }

  onFileSelected(result: FileUploadResult): void {
    if (result.isValid) {
      this.selectedFiles = result.fileName;
      this.fileBase64 = result.fileBase64;
    }
  }

  // New method to handle file removal from common component
  onRemoveImage(): void {
    this.selectedFiles = null;
    this.fileBase64 = null;
    this.existingImageUrl = null;
    this.existingFileName = null;

    // Reset the file upload component
    if (this.fileUploadComponent) {
      this.fileUploadComponent.reset();
    }

    this.toaster.success('Image has been deleted');
  }

  selectCurrency(event: any) {
    if (!!event.id) {
      this.selectedCurrency = event?.id;
    }
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.submitted = true;
    if (!this.productProjectForm.valid) {
      return;
    }
    const projecPayload = {
      productId: this.productProjectData.productId || 0,
      projectId: this.productProjectData.projectId || 0,
      productConfigId: this.productProjectData.productConfigId || 0,
      productCountries: this.productProjectForm.controls['country'].value?.map(
        (country: any) => country.id
      ),
      name: this.productProjectForm.controls['productName'].value,
      countryId: this.productProjectForm.controls['defaultCountry'].value?.id,
      productContentsFile: this.selectedFiles,
      productContentsImage: this.fileBase64,
      unitId: this.unitId,
      description: this.productProjectForm.controls['description'].value,
      currencyId: this.selectedCurrency || this.currencyItem?.id,
      isTurnOffCost: !this.isCostTurnedOff,
    };
    this.saveNewMyProductProjectEvent.emit(projecPayload);
    this.modal.close();
  }
}
